/**
 * @fileoverview Agent definition for chapter-entity-detector-v2.
 *
 * Scans a chapter's text to identify which known characters are present.
 *
 * @category narrative.chapters.operations
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-entity-detector-v2',
  kind: 'primitive',
  name: 'Chapter Entity Detector',
  description: "Scans a chapter's text to identify which known characters and world elements are present.",
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.operations',
    usedBy: [
      'primitives/use-chapter-entity-detector-v2.ts',
      'use-character-snapshotter-single-v2.ts',
    ],
    usedInComposites: [
      'character-snapshotter-v2',
    ],
    relatedAgents: [
      'chapter-splitter-v2',
      'character-snapshotter-single-v2',
    ],
  },
};
